import { run as resetToAuto } from './ResetToAutoStrategy';
import { waypointStrategySelector } from './WaypointStrategySelector';

/**
 * Registry of connector-fix strategies — "Fix Lines" toolbar button.
 * Same {key, label, enabled, run} shape as ImportStrategyRegistry.js.
 * run(connector, fromShape, toShape) mutates ONE connector in place; UmlCanvasEngine
 * applies it to every connector (with resolved shapes) and notifies once.
 */
export const CONNECTOR_FIX_STRATEGIES = [
    { key: 'straightenExisting', label: 'Straighten Existing Anchors', enabled: true, run: waypointStrategySelector },
    { key: 'resetToAuto', label: 'Reset to Auto', enabled: true, run: (connector) => resetToAuto(connector) },
];

/**
 * @param {string} key
 * @returns {object|null}
 */
export function getConnectorFixStrategy(key) {
    return (
        CONNECTOR_FIX_STRATEGIES.find(function matchKey(strategy) {
            return strategy.key === key;
        }) || null
    );
}
